import { Button } from "@faire/web/slate-deprecated/Button";
import { Lock } from "@faire/web/slate/icons/foundation/Lock";
import { Spacer } from "@faire/web/slate/spacing";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

interface ISignUpCTAProps {
  disabled?: boolean;
  handleSubmit: () => void;
  isBatch12SignUpCopyEnabled: boolean;
}

export const SignUpCTA: React.FC<ISignUpCTAProps> = ({
  disabled,
  handleSubmit,
  isBatch12SignUpCopyEnabled,
}) => {
  return (
    <Button
      onClick={handleSubmit}
      data-test-id="createAccountButton"
      style={{ width: "100%" }}
      disabled={disabled}
      variant="primary"
    >
      {isBatch12SignUpCopyEnabled ? (
        <>
          <Lock lockType="foundation" fontSize={16} />
          <Spacer width={4} />
          <StrictLocalMsg
            id="AXLhmN"
            defaultMessage="Unlock wholesale pricing"
            description={{
              text: "Call to action to begin the sign up flow (CTA button text)",
              img: "https://cdn.faire.com/fastly/b4af2f5790b4e0752944ac056de2906b679cd6fd241b5101f29e827cc2523f2f.png",
            }}
          />
        </>
      ) : (
        <StrictLocalMsg
          id="ekYhCW"
          defaultMessage="Sign up for free"
          description={{
            text: "Call to action to begin the sign up flow (CTA button text)",
            img: "https://cdn.faire.com/fastly/b4af2f5790b4e0752944ac056de2906b679cd6fd241b5101f29e827cc2523f2f.png",
          }}
        />
      )}
    </Button>
  );
};
